
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
             <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                placeholder="Nom"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Fournisseur"
              label-for="Fournisseur"
            >
            <b-form-select
                v-model="form.supplier"
                :options="supplierOptions"
              />
            </b-form-group>

          </b-col>

          

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Référence fournisseur"
              label-for="basicInput"
            >
             <validation-provider
              #default="{ errors }"
              name="Référence fournisseur"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.supplier_reference"
                :plaintext="readOnly"
                placeholder="Nom"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Catégorie"
              label-for="Type"
            >
            <v-select
                v-model="form.color_categories"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
              
                multiple
                :options="colorCatChoices"
              />
             
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Photo"
              label-for="Photo"
            >
            
            <b-media vertical-align="top" v-if="file!==null">
                  <template #aside>
                    <b-img
                      :src="file"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editPhoto()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
            required
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded($event)"
            />
           
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix"
              label-for="Prix"
            >
             <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
              required
                id="Prix"
                v-model="form.price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <!-- <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Code"
              label-for="Code"
            >
             <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
              required
                id="Code"
                v-model="form.code"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="#ffffff"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col> -->

          <!-- <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Teinte (hue)"
              label-for="Teinte"
            >
            <validation-provider
              #default="{ errors }"
              name="Teinte"
             
            >
              <b-form-input
              
                id="Hue"
                v-model="form.hue"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="0"
              />
              
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col> -->

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Teinte (hue)"
              label-for="Teinte"
            >
            <validation-provider
              #default="{ errors }"
              name="Teinte"
             
            >
              <b-form-input
              
                id="Hue"
                v-model="form.hue_app"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="0"
              />
              
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Saturation"
              label-for="Saturation"
            >
            <validation-provider
              #default="{ errors }"
              name="Saturation"
             
            >
              <b-form-input
              
                id="Saturation"
                v-model="form.saturation"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="0"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
            <b-form-group
              label="Color ID"
              label-for="Color ID"
            >
            
              <b-form-input
              
                id="basicInput"
                v-model="form.type"
                :plaintext="readOnly"
                placeholder="Color ID"
               
              />
            
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Matière"
              label-for="Matière"
            >
            <b-form-select
                v-model="form.material"
                :options="materialOptions"
              />
            </b-form-group>

            <b-form-group
              label="Ordre d'affichage"
              label-for="Ordre d'affichage"
            >
           
            
              <b-form-input
                id="Ordre d'affichage"
                v-model="form.order_display"
                :plaintext="readOnly"
                type="number"
                step="1"
                placeholder="Ordre d'affichage"
               
              />
             
            </b-form-group>

          </b-col>

         
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Luminosité"
              label-for="Luminosité"
            >
            <validation-provider
              #default="{ errors }"
              name="Luminosité"
             
            >
              <b-form-input
              
                id="Luminosité"
                v-model="form.brightness"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="0"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            
            </b-form-group>
          
          </b-col>

        </b-row>
      </b-form>
      </validation-observer>

    </b-card>
  <b-button v-if="edition==false"
     @click="createColor"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="editColor"
    >
    Enregistrer
    </b-button>


  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput, BFormSelect,BOverlay, BForm, BRow, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea,BCardText, BMedia, BImg} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest,Utils} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'ColorForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BCardText, 
    BMedia, 
    BImg,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    BOverlay,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
      return {
          currentBase64:null,
          file: null,
          edition:false,
          loading:true,
          color_categories:[],
          materialOptions:['plastic','metal'],
          supplierOptions:['fournisseur 1','fournisseur 2'],
          colorCatChoices:[],
          form:{
            name:"",
            order_display:0,
            color_categories:null,
            material:null,
            file:'',
            type:null,
            code:'',
            price:0,
            photo:'',
            hue:null,
            hue_app:null,
            supplier_reference:null,
            supplier:null,
            brightness:null,
            saturation:null
          },
      }
  },
  props: ['color', 'readOnly'],
  methods:{
    editPhoto() {
      this.file=null
    },
    async getColorCategories() {
      let color_categories = await APIRequest.list('color-categories')
      this.color_categories=color_categories[0];
      this.colorCatChoices=Utils.formatSelect(this.color_categories,'name','id')
      
    },
    async createColor()
    {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {
          var color_categories=this.form.color_categories
          this.form.color_categories=[]
          if(color_categories!=null)
          {
            for(var i=0;i<color_categories.length;i++)
            {
              this.form.color_categories[i]={}
              this.form.color_categories[i].id=color_categories[i].value
            }
          }
         let color= await APIRequest.create('colors',this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'La couleur a bien été créée !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        
          this.$router.push({name:'editColor', params: { id: color.id }})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
      })
      
    },
    async editColor()
    {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
      this.loading=true
        try {

          var color_categories=this.form.color_categories
          this.form.color_categories=[]
          if(color_categories!=null)
          {
            for(var i=0;i<color_categories.length;i++)
            {
              this.form.color_categories[i]={}
              this.form.color_categories[i].id=color_categories[i].value
            }
          }
        
          await APIRequest.update('colors',this.color.id,this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'La couleur a bien été modifiée !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
         
         // this.$router.push({name:'colors'})
         this.loading=false
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
      })
      
    },
    fileAdded(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase64=reader.result
              this.file=this.currentBase64
              this.form.photo=this.currentBase64
          }
          else
          {
              this.file=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
     
      
  },
  async mounted(){
    await this.getColorCategories();
    if(this.color!=null)
    {
      this.form=this.color
      this.file=this.color.photo
      this.edition=true
      if(this.color.color_categories!=null)
      {
        for(let i=0;i<this.color.color_categories.length;i++)
        {
          for(let j=0;j<this.colorCatChoices.length;j++)
          {
            if(this.color.color_categories[i].id == this.colorCatChoices[j].value)
            {
              this.form.color_categories[i] = this.colorCatChoices[j]
            }
          }
        }
      }
    }
    
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>